import { createContext, useContext, type ReactNode } from 'react';
import { useTimer } from '@/hooks/useTimer';

type TimerContextType = ReturnType<typeof useTimer>;

const TimerContext = createContext<TimerContextType | null>(null);

export function TimerProvider({ children }: { children: ReactNode }) {
  const timerValue = useTimer();
  return <TimerContext.Provider value={timerValue}>{children}</TimerContext.Provider>;
}

export function useTimerContext(): TimerContextType {
  const ctx = useContext(TimerContext);
  if (!ctx) throw new Error('useTimerContext must be used within TimerProvider');
  return ctx;
}
